import en from './en';
import fr from './fr';
import de from './de';
import it from './it';
import ja from './ja';
import es from './es';
import ru from './ru';
import cn from './cn';
import cn_TW from './cn-TW';
import cs from './cs';
import pl from './pl'
import pt from './pt'

export default {
  en,
  fr,
  de,
  it,
  ja,
  es,
  ru,
  cn,
  cn_TW,
  cs,
  pl,
  pt
}
